export enum MailMode {
  Read,
  Compose,
}

function officeMailMode(): MailMode {
  try {
    const mailItem = Office.context.mailbox.item
    // @ts-ignore
    if (mailItem && mailItem._data$p$0) {
      // @ts-ignore
      return mailItem._data$p$0._data$p$0.itemType === 4 ? MailMode.Compose : MailMode.Read
    } else if (mailItem && mailItem.displayReplyForm === undefined) {
      return MailMode.Compose
    } else {
      return MailMode.Read
    }
  } catch {
    return MailMode.Read
  }
}

function officeEventMode(): MailMode {
  try {
    const mailItem = Office.context.mailbox.item
    if (mailItem && mailItem.subject.getAsync) {
      return MailMode.Compose
    } else {
      return MailMode.Read
    }
  } catch {
    return MailMode.Read
  }
}

export function officeIsComposeMode(): boolean {
  if (officeIsAppointmentItem) {
    return officeEventMode() === MailMode.Compose
  } else {
    return officeMailMode() === MailMode.Compose
  }
}

export function officeItemType(): string {
  return Office.context.mailbox.item.itemType || Office.MailboxEnums.ItemType.Message
}

export function officeIsMessageItem(): boolean {
  return officeItemType() == Office.MailboxEnums.ItemType.Message
}

export function officeIsAppointmentItem(): boolean {
  return officeItemType() == Office.MailboxEnums.ItemType.Appointment
}

export function officeIsInvitationItem(): boolean {
  return officeIsMessageItem() && !!Office.context.mailbox.item.start
}

const exportFunctions = {
  itemType: officeItemType,
  isCompose: officeIsComposeMode,
  isMessage: officeIsMessageItem,
  isAppointment: officeIsAppointmentItem,
  isInvitation: officeIsInvitationItem,
}

export default exportFunctions
